import { render, staticRenderFns } from "./AppOrderSelectorElement.vue?vue&type=template&id=081ebc45&scoped=true"
import script from "./AppOrderSelectorElement.vue?vue&type=script&lang=ts"
export * from "./AppOrderSelectorElement.vue?vue&type=script&lang=ts"
import style0 from "./AppOrderSelectorElement.vue?vue&type=style&index=0&id=081ebc45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ebc45",
  null
  
)

export default component.exports